import React from 'react';
import { GAME_TYPES } from '../../utils/constants';

const GameRecapCard = ({ gameRecap }) => {
  if (!gameRecap) return null;
  const gameTypeInfo = GAME_TYPES.find(g => g.id === gameRecap.gameType);
  const weatherIcons = { sunny: '☀️', cloudy: '☁️', rainy: '🌧️', windy: '💨' };

  // Individual stats card
  if (gameRecap.isIndividual) {
    const score = gameRecap.myScore || 0;
    const diff = gameRecap.myDiff || 0;
    const bestHole = gameRecap.bestHole;
    return (
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg p-4 mb-3 border-2 border-blue-500">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <span className="text-2xl">{gameTypeInfo?.emoji || '🏌️'}</span>
            <div>
              <p className="text-white font-bold">{gameTypeInfo?.name || 'Game'} - My Stats</p>
              <p className="text-gray-400 text-sm">{gameRecap.courseName}</p>
            </div>
          </div>
          {gameRecap.weather && (
            <span className="text-sm text-gray-400">
              {weatherIcons[gameRecap.weather] || ''} <span className="capitalize">{gameRecap.weather}</span>
            </span>
          )}
        </div>
        <div className="bg-gray-900 rounded-lg p-3 text-center mb-2">
          <p className="text-gray-400 text-xs">Score</p>
          <p className={`text-3xl font-bold ${diff <= 0 ? 'text-green-400' : 'text-red-400'}`}>{score}</p>
          <p className="text-sm text-gray-400">({diff >= 0 ? '+' : ''}{diff} to par)</p>
        </div>
        {bestHole && (
          <div className="text-center text-sm text-gray-300">
            Best: Hole {bestHole.hole} — {bestHole.score} ({bestHole.diff >= 0 ? '+' : ''}{bestHole.diff})
          </div>
        )}
      </div>
    );
  }

  // Group stats card
  return (
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg p-4 mb-3 border-2 border-[#16a34a]">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <span className="text-2xl">{gameTypeInfo?.emoji || '🏌️'}</span>
          <div>
            <p className="text-white font-bold">{gameTypeInfo?.name || 'Game'}</p>
            <p className="text-gray-400 text-sm">{gameRecap.courseName}</p>
          </div>
        </div>
        {gameRecap.weather && (
          <span className="text-sm text-gray-400">
            {weatherIcons[gameRecap.weather] || ''} <span className="capitalize">{gameRecap.weather}</span>
          </span>
        )}
      </div>
      {gameRecap.winnerName && (
        <div className="bg-[#16a34a] bg-opacity-20 rounded-lg p-2 mb-2 text-center">
          <p className="text-[#16a34a] font-bold">🏆 {gameRecap.winnerName}</p>
        </div>
      )}
      <div className="space-y-1">
        {gameRecap.players?.sort((a, b) => (gameRecap.finalScores?.[a.userId] || 0) - (gameRecap.finalScores?.[b.userId] || 0)).map((p, i) => {
          const score = gameRecap.finalScores?.[p.userId] || 0;
          const diff = score - (gameRecap.totalPar || 72);
          return (
            <div key={p.userId} className="flex items-center justify-between text-sm">
              <span className="text-white">{i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `${i + 1}.`} {p.name}</span>
              <span className={`font-bold ${diff <= 0 ? 'text-green-400' : 'text-red-400'}`}>{score} ({diff >= 0 ? '+' : ''}{diff})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GameRecapCard;
